import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RenaultLocalCampaignOrderDTO } from 'src/app/models/renault-local-campaign-order-dto';
import { LocalCampaignOrderService } from 'src/app/services/local-campaign-order.service';
import { Thumbs } from 'swiper';


@Component({
  selector: 'declined-reason-modal',
  templateUrl: './declined-reason-modal.component.html',
  styleUrls: ['./declined-reason-modal.component.scss']
})
export class DeclinedReasonComponent implements OnInit {

  dataform: FormGroup;
  submitted = 0;
  @Input() idOrder;
  order: RenaultLocalCampaignOrderDTO;

  constructor(public activeModal: NgbActiveModal,
    private orderService: LocalCampaignOrderService) { }

  ngOnInit(): void {

    this.dataform = new FormGroup({
      reason: new FormControl(null, [Validators.required])
    });

    if (this.idOrder) {
      this.orderService.get(this.idOrder).subscribe(res => {
        this.order = res;
        this.dataform.controls.reason.setValue(this.order.DeclinedReason);
      })
    }


  }

  save() {

    this.submitted = 1;
    if (this.dataform.invalid) return;

    this.activeModal.close(this.dataform.controls.reason.value);


  }

  closeModal() {
    this.activeModal.close(null);
  }


}
